<template>
  <div class="user-info">
    <div class="user-info-avatar" :style="style">{{ subName }}</div>
  </div>
</template>

<script>
export default {
  name: 'LettersAvatar',
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      default: 'big'

    },
    size: {}
  },
  computed: {
    dimensions() {
      let size
      if (this.size) return this.size

      if (this.type === 'mini') size = 40
      if (this.type === 'big') size = 75
      return size
    },
    subName() {
      return this.name ? this.name.substr(0, 2) : ' ? '
    },
    style() {
      return {
        backgroundColor: this.backgroundColor,
        width: `${this.dimensions}px`,
        height: `${this.dimensions}px`,
        borderRadius: this.type === 'big' ? `${this.dimensions}px` : '4px',
        fontSize: '100%',
        lineHeight: `${this.dimensions}px`,
      }
    },
    backgroundColor() {
      let name = this.subName ? this.subName : ' '

      let hash = 0;
      if (name.length === 0) return hash;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 4) - hash);
        hash = hash & hash;
      }
      let color = '';
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 255;
        color += ('00' + value.toString(16)).substr(-2);
      }

      return '#' + color

    }
  }
};
</script>
<style scoped lang="scss">
.user-info-avatar {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  text-align: center;
  color: #000;

  font-weight: 500;
  font-size: 32px;
  line-height: 41px;
}

.user-info-name {
  display: inline-block;
}
</style>
